/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_authorizePost } from '../models/Body_authorizePost';
import type { Body_introspect } from '../models/Body_introspect';
import type { Body_revoke } from '../models/Body_revoke';
import type { Body_token } from '../models/Body_token';
import type { ConsentDecisionRequest } from '../models/ConsentDecisionRequest';
import type { ConsentInfoResponse } from '../models/ConsentInfoResponse';
import type { OAuthIntrospectionResponse } from '../models/OAuthIntrospectionResponse';
import type { OAuthResponseMode } from '../models/OAuthResponseMode';
import type { OAuthResponseType } from '../models/OAuthResponseType';
import type { OAuthTokenResponse } from '../models/OAuthTokenResponse';
import type { OAuthUserInfoResponse } from '../models/OAuthUserInfoResponse';
import type { TokenExchangeResponse } from '../models/TokenExchangeResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OauthService {
    /**
     * OAuth 2.0 Authorization Endpoint (GET).
     *
     * Standard OAuth authorization via query parameters.
     *
     * OAuth 2.0 Authorization Endpoint (GET).
     *
     * Standard OAuth authorization via query parameters.
     * @param responseType
     * @param clientId
     * @param redirectUri
     * @param scope
     * @param state
     * @param nonce
     * @param codeChallenge
     * @param codeChallengeMethod
     * @param idTokenHint
     * @param responseMode
     * @param resource
     * @returns string HTML form POST response (when response_mode=form_post)
     * @throws ApiError
     */
    public static authorizeGet(
        responseType: OAuthResponseType,
        clientId: string,
        redirectUri: string,
        scope: string = '',
        state?: (string | null),
        nonce?: (string | null),
        codeChallenge?: (string | null),
        codeChallengeMethod?: 'S256',
        idTokenHint?: (string | null),
        responseMode?: (OAuthResponseMode | null),
        resource?: (string | null),
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/oauth/authorize',
            query: {
                'response_type': responseType,
                'client_id': clientId,
                'redirect_uri': redirectUri,
                'scope': scope,
                'state': state,
                'nonce': nonce,
                'code_challenge': codeChallenge,
                'code_challenge_method': codeChallengeMethod,
                'id_token_hint': idTokenHint,
                'response_mode': responseMode,
                'resource': resource,
            },
            errors: {
                302: `Redirect to branded error page (browser, invalid client/redirect_uri)`,
                303: `Redirect to login page or client callback with error`,
                400: `Invalid request (unvalidated redirect_uri or client)`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * OAuth 2.0 Authorization Endpoint (POST).
     *
     * Accepts form-encoded parameters for flows where payloads are too large
     * for query strings (e.g., Entra EAM with id_token_hint and claims).
     *
     * OAuth 2.0 Authorization Endpoint (POST).
     *
     * Accepts form-encoded parameters for flows where payloads are too large
     * for query strings (e.g., Entra EAM with id_token_hint and claims).
     * @param formData
     * @returns string HTML form POST response (when response_mode=form_post)
     * @throws ApiError
     */
    public static authorizePost(
        formData: Body_authorizePost,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/oauth/authorize',
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                302: `Redirect to branded error page (browser, invalid client/redirect_uri)`,
                303: `Redirect to login page or client callback with error`,
                400: `Invalid request (unvalidated redirect_uri or client)`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * OAuth 2.0 token endpoint — dispatches on grant_type (RFC 6749 §4.1/§6, RFC 8693).
     *
     * Handles authorization_code (incl. public clients via PKCE), refresh_token, and
     * the RFC 8693 token-exchange grant that issues an ID-JAG for MCP
     * Enterprise-Managed Authorization (gated by the oauth_id_jag flag).
     *
     * OAuth 2.0 token endpoint — dispatches on grant_type (RFC 6749 §4.1/§6, RFC 8693).
     *
     * Handles authorization_code (incl. public clients via PKCE), refresh_token, and
     * the RFC 8693 token-exchange grant that issues an ID-JAG for MCP
     * Enterprise-Managed Authorization (gated by the oauth_id_jag flag).
     * @param formData
     * @param authorization
     * @returns any Successful Response
     * @throws ApiError
     */
    public static token(
        formData: Body_token,
        authorization?: (string | null),
    ): CancelablePromise<(OAuthTokenResponse | TokenExchangeResponse)> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/oauth/token',
            headers: {
                'authorization': authorization,
            },
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * OAuth 2.0 Token Introspection (RFC 7662)
     * @param formData
     * @param authorization
     * @returns OAuthIntrospectionResponse Successful Response
     * @throws ApiError
     */
    public static introspect(
        formData: Body_introspect,
        authorization?: (string | null),
    ): CancelablePromise<OAuthIntrospectionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/oauth/introspect',
            headers: {
                'authorization': authorization,
            },
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                400: `Malformed request (invalid_request)`,
                401: `Client authentication failed (invalid_client)`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Revoke a token + its refresh family (RFC 7009); always 200 per §2.2.
     * Revoke a token + its refresh family (RFC 7009); always 200 per §2.2.
     * @param formData
     * @param authorization
     * @returns any Token revoked (empty body)
     * @throws ApiError
     */
    public static revoke(
        formData: Body_revoke,
        authorization?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/oauth/revoke',
            headers: {
                'authorization': authorization,
            },
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                400: `Malformed request (invalid_request)`,
                401: `Client authentication failed (invalid_client)`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * JWKS (JSON Web Key Set) endpoint.
     *
     * Returns the public keys used to verify JWT signatures issued by this service.
     * This endpoint is required for OIDC/OAuth2 implementations.
     *
     * Path: /auth/oauth/keys
     *
     * Args:
     * oauth_service: OAuth service for fetching the tenant's signing keys
     *
     * Returns:
     * dict: JWKS document containing public keys in standard format
     *
     * JWKS (JSON Web Key Set) endpoint.
     *
     * Returns the public keys used to verify JWT signatures issued by this service.
     * This endpoint is required for OIDC/OAuth2 implementations.
     *
     * Path: /auth/oauth/keys
     *
     * Args:
     * oauth_service: OAuth service for fetching the tenant's signing keys
     *
     * Returns:
     * dict: JWKS document containing public keys in standard format
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getJwks(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/oauth/keys',
        });
    }
    /**
     * OIDC UserInfo Endpoint.
     *
     * Returns claims about the authenticated user based on the access token's scope.
     *
     * The access token must be provided in the Authorization header as a Bearer token.
     *
     * Args:
     * authorization: Authorization header containing Bearer token
     * tenant_id: Current tenant ID from request context
     * oauth_service: OAuth service for token validation and user lookup
     *
     * Returns:
     * User info claims based on the token's scope
     *
     * Raises:
     * HTTPException: 401 if token is missing, invalid, or expired
     *
     * OIDC UserInfo Endpoint.
     *
     * Returns claims about the authenticated user based on the access token's scope.
     *
     * The access token must be provided in the Authorization header as a Bearer token.
     *
     * Args:
     * authorization: Authorization header containing Bearer token
     * tenant_id: Current tenant ID from request context
     * oauth_service: OAuth service for token validation and user lookup
     *
     * Returns:
     * User info claims based on the token's scope
     *
     * Raises:
     * HTTPException: 401 if token is missing, invalid, or expired
     * @param authorization
     * @returns OAuthUserInfoResponse Successful Response
     * @throws ApiError
     */
    public static userinfo(
        authorization?: (string | null),
    ): CancelablePromise<OAuthUserInfoResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/oauth/userinfo',
            headers: {
                'authorization': authorization,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * OAuth/OIDC End Session Endpoint
     * Handle OAuth/OIDC logout request and clear MFA session
     * @param idTokenHint ID token to identify the user
     * @param postLogoutRedirectUri URL to redirect after logout
     * @param state State parameter
     * @returns string Successful Response
     * @throws ApiError
     */
    public static handleOauthLogout(
        idTokenHint?: (string | null),
        postLogoutRedirectUri?: (string | null),
        state?: (string | null),
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/oauth/logout',
            query: {
                'id_token_hint': idTokenHint,
                'post_logout_redirect_uri': postLogoutRedirectUri,
                'state': state,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Consent Info
     * Data for the consent screen, derived from the pending auth session cookie.
     * @param pendingAuthSession
     * @returns ConsentInfoResponse Successful Response
     * @throws ApiError
     */
    public static getConsentInfo(
        pendingAuthSession?: (string | null),
    ): CancelablePromise<ConsentInfoResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/oauth/consent-info',
            cookies: {
                'pending_auth_session': pendingAuthSession,
            },
            errors: {
                401: `Pending auth session cookie missing or invalid`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Switch User
     * Drop the authenticated identity from the pending session so the same authorization request re-prompts login ('Not you?').
     * @param pendingAuthSession
     * @returns void
     * @throws ApiError
     */
    public static switchUser(
        pendingAuthSession?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/oauth/consent/switch-user',
            cookies: {
                'pending_auth_session': pendingAuthSession,
            },
            errors: {
                401: `Pending auth session cookie missing or invalid`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Consent Decision
     * Apply the user's consent decision: approve persists the grant and completes the authorization; deny returns access_denied to the client.
     * @param requestBody
     * @param pendingAuthSession
     * @returns string Successful Response
     * @throws ApiError
     */
    public static postConsent(
        requestBody: ConsentDecisionRequest,
        pendingAuthSession?: (string | null),
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/oauth/consent',
            cookies: {
                'pending_auth_session': pendingAuthSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Pending auth session cookie missing or invalid`,
                422: `Validation Error`,
            },
        });
    }
}
